import React, { useContext } from 'react';
import { BooleanColumn, NumericalColumn, CustomColumn, StringColumn } from 'baseui/data-table';
import { useStyletron } from 'baseui';
import { Button, KIND } from 'baseui/button';
import { StyledLink } from 'baseui/link';
import { EMPTY_ARRAY, CustomDateColumn, EMPTY_STRING, ModalContext, AppContext } from 'commons-ui';

import usePagesService from 'pages/useService';

export const COL_NAMES = {
	code: 'code',
	description: 'description',
	validFrom: 'validFrom',
	validTill: 'validTill',
	isOpen: 'isOpen',
	isDisabled: 'isDisabled',
	allowedPaymentModes: 'allowedPaymentModes',
	segmentsInclusive: 'segmentsInclusive',
	segmentsExclusive: 'segmentsExclusive',
	maxRedemptionsPerPerson: 'maxRedemptionsPerPerson',
	redemptionInterval: 'redemptionInterval',
	createdOn: 'createdOn',
	uptoCashback: 'uptoCashback'
};

export const columnConfigs = [
	CustomColumn({
		title: 'Code',
		mapDataToValue: (data: any) => data[COL_NAMES.code] || EMPTY_STRING,
		maxWidth: 250,
		minWidth: 200,
		renderCell: (params: any) => {
			const { value: couponCode } = params;
			const { getCouponTnc } = usePagesService();
			const { setModalConfig } = useContext(ModalContext);
			const { showAlert } = useContext(AppContext);
			const [css] = useStyletron();

			const handleOnClick = (event: any) => {
				event.preventDefault();
				event.stopPropagation();

				(async () => {
					try {
						const { tncHTML, couponId } = await getCouponTnc({ couponCode });
						setModalConfig({
							isOpen: true,
							header: 'Terms & Conditions',
							content: (
								<>
									<div
										className={css({
											padding: '20px',
											flexDirection: 'column'
										})}>
										<div
											className={css({
												display: 'flex',
												flexDirection: 'row',
												gap: '20px'
											})}>
											<div
												className={css({
													fontWeight: 'bold'
												})}>
												Coupon ID:
											</div>
											<div>{couponId || '-'}</div>
										</div>

										<div
											className={css({
												marginTop: '30px'
											})}>
											<div>T&C</div>
											<div
												className={css({
													padding: '20px'
												})}
												// eslint-disable-next-line react/no-danger
												dangerouslySetInnerHTML={{ __html: tncHTML }}
											/>
										</div>
									</div>
								</>
							)
						});
					} catch (error) {
						showAlert('Error in fetching coupon T&C', { type: 'error' });
					}
				})();
			};
			return (
				<Button
					kind={KIND.tertiary}
					onClick={handleOnClick}
					overrides={{
						Root: {
							style: ({ $theme }) => ({
								color: $theme.colors.primaryA,
								height: '100%',
								width: '100%',
								fontSize: '12px',
								fontWeight: 'normal'
							})
						}
					}}>
					<StyledLink>{couponCode}</StyledLink>
				</Button>
			);
		}
	}),
	CustomDateColumn({
		title: 'Valid From',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.validFrom
	}),
	CustomDateColumn({
		title: 'Valid Till',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.validTill
	}),
	BooleanColumn({
		title: 'isOpen',
		mapDataToValue: (data: any) => data[COL_NAMES.isOpen],
		maxWidth: 200
	}),
	CustomColumn({
		title: 'Is Deployed',
		mapDataToValue: (data: any) => data[COL_NAMES.isDisabled],
		maxWidth: 200,
		renderCell: (params: any) => {
			const { value } = params;
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: !value ? 'green' : 'red',
						height: '100%',
						width: '100%'
					})}
				/>
			);
		}
	}),
	CustomColumn({
		title: 'allowedPaymentModes',
		mapDataToValue: (data: any) => (data[COL_NAMES.allowedPaymentModes] || EMPTY_ARRAY).join(','),
		renderCell: (params: any) => params.value
	}),
	CustomColumn({
		title: 'segmentsInclusive',
		mapDataToValue: (data: any) => (data[COL_NAMES.segmentsInclusive] || EMPTY_ARRAY).join(','),
		renderCell: (params: any) => params.value
	}),
	CustomColumn({
		title: 'segmentsExclusive',
		mapDataToValue: (data: any) => (data[COL_NAMES.segmentsExclusive] || EMPTY_ARRAY).join(','),
		renderCell: (params: any) => params.value
	}),
	NumericalColumn({
		title: 'maxRedemptionsPerPerson',
		mapDataToValue: (data: any) => data[COL_NAMES.maxRedemptionsPerPerson] || '',
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Redemption Interval',
		mapDataToValue: (data: any) => data[COL_NAMES.redemptionInterval] || '',
		maxWidth: 200
	}),
	CustomDateColumn({
		title: 'Created On',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdOn
	}),
	NumericalColumn({
		title: 'Upto Cashback',
		mapDataToValue: (data: any) => data[COL_NAMES.uptoCashback] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Description',
		mapDataToValue: (data: any) => data[COL_NAMES.description] || ''
	}),
	BooleanColumn({
		title: 'Is Disabled',
		mapDataToValue: (data: any) => data[COL_NAMES.isDisabled]
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Disabled',
		filterLabel: 'Active Coupons',
		filterValue: false
	}
];
